import(/* webpackMode: "eager" */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/app/[locale]/error.tsx");
